export default {
  props: {
    emptyText: {
      type: String
    }
  },

  data() {
    return {
      isSelectAll: true
    }
  },

  computed: {
    defaultEmptyText() {
      if (this.emptyText) return this.emptyText
      return this.$t('c.table.textEmpty')
    }
  },

  mounted() {
    if (this.selectionColumn && this.isSelectAll) {
      this.selectAll()
    }
  },

  watch: {
    data() {
      if (this.selectionColumn && this.isSelectAll) {
        this.$nextTick(() => this.selectAll())
      }
    }
  },

  methods: {
    changeSelectAll(selection) {
      this.isSelectAll = (selection.length > 0)
    },

    selectAll(ref = 'table') {
      const table = this.$refs[ref]

      this.data.forEach((row) => {
        table.toggleRowSelection(row, true)
      })
    }
  }
}
